/* eslint-disable */
<template>
  <v-container>
    <v-card>
      <v-card-title>My Retakes</v-card-title>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="retakes"
        dense
        class="elevation-1 pt-0"
        item-key="unit_name"
      >
        <template v-slot:[`item.actions`]>
          <v-btn x-small outlined color="accent" class="mx-1"> view </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "RetakesComponent",
  data: () => ({
    retakes: [],
    headers: [
      { text: "Unit Code", sortable: false, value: "unit" },
      { text: "Unit Name", align: "start", sortable: false, value: "paper" },
      { text: "Stage", align: "start", sortable: false, value: "stage" },
      { text: "Semester", sortable: false, value: "intakeSemester" },
      { text: "Actions", value: "actions" },
    ],
  }),
};
</script>
